import { Button, UserAvatar } from '@/components';
import { DynamIQLogo } from '@/components/Icons';
import { useGetCurrentUser } from '@/modules/Users/queries';
import { goToJiraMakeRequestLink } from '@/shared/utils/jira-links';
import { useTranslation } from 'react-i18next';
import { Charts, Menu, SyncStatus } from './components';

export const Header = () => {
  const { t } = useTranslation();

  const { data: currentUser } = useGetCurrentUser();

  return (
    <div className="flex w-full justify-center bg-gradient">
      <div className=" flex w-full max-w-screen-2xl flex-col gap-10 pb-[30px] pt-5">
        <div className="flex items-center justify-between text-white">
          <DynamIQLogo />
          <div className="flex items-center gap-3">
            <UserAvatar size="small" name={currentUser?.fullName} />
            {/*<Notifications /> Uncomment when this feature is done*/}
            <Menu />
          </div>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-lg text-white">
            {currentUser?.fullName &&
              t('header_greeting', { username: currentUser?.fullName })}
          </span>
          <div className="flex items-center gap-5">
            <SyncStatus />
            <Button variant="secondary" onClick={goToJiraMakeRequestLink}>
              {t('make_request')}
            </Button>
          </div>
        </div>
        <Charts />
      </div>
    </div>
  );
};
